import React, { Component } from "react";
import PropTypes from "prop-types";
import Tooltip from "./Tooltip";

export default class TooltipButton extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isLocked: false,
			isVisible: false
		};
		this.tooltipButtonRef = React.createRef();
	}
	componentDidMount() {
		window.addEventListener("resize", this.resetState);
		document.addEventListener("scroll", this.resetState);
	}
	componentWillUnmount() {
		window.removeEventListener("scroll", this.resetState);
		window.removeEventListener("resize", this.resetState);
	}
	resetState = () => {
		this.setState({ isLocked: false, isVisible: false });
	};
	handleWindowClick = (e) => {
		if (!e || !e.target) return;

		let currentElement = e.target;
		while (currentElement) {
			if (currentElement.classList.contains("dfa-tooltip-button-text")) return;
			currentElement = currentElement.parentElement;
		}
		this.setState({
			isLocked: false,
			isVisible: false
		});
		window.removeEventListener("click", this.handleWindowClick);
	};
	toggleLocked = () => {
		this.setState({
			isLocked: !this.state.isLocked,
			isVisible: !this.state.isLocked
		});

		window.requestAnimationFrame(() => {
			if (this.state.isLocked) {
				window.addEventListener("click", this.handleWindowClick);
			} else {
				window.removeEventListener("click", this.handleWindowClick);
			}
		});
	};
	setVisible = (state) => {
		if (!this.state.isLocked) {
			this.setState({
				isVisible: state
			});
		}
	};

	render() {
		const {
			content,
			className = "",
			buttonClassName = "",
			id,
			position = "bottom",
			tooltipPosition = "left",
			clickable = true,
			dataLabel = "",
			dataQA = ""
		} = this.props;

		const { isVisible } = this.state;
		return (
			<div className={`dfa-tooltip-button ${className}`} data-testid="tooltipButton">
				<button
					className={
						"pdf--type t-label-xs-heavy collection" +
						buttonClassName +
						(this.state.isLocked ? " dfa-tooltip-button-locked" : "")
					}
					ref={this.tooltipButtonRef}
					onClick={() => this.toggleLocked()}
					onMouseEnter={() => this.setVisible(true)}
					onMouseLeave={() => this.setVisible(false)}
					aria-label="tooltip"
					data-tip={decodeURIComponent((content + "").replace(/\+/g, "%20"))}
					data-for={id}
					data-event={isVisible || ""}
					data-event-off={isVisible || ""}
					data-label={dataLabel}
					data-qa={dataQA}
				>
					{this.props.children}
				</button>
				<Tooltip
					id={id}
					position={position}
					tooltipPosition={tooltipPosition}
					isVisible={isVisible}
					buttonRef={this.tooltipButtonRef}
					clickable={clickable}
				/>
			</div>
		);
	}
	static propTypes = {
		data: PropTypes.shape({
			className: PropTypes.string,
			buttonClassName: PropTypes.string,
			id: PropTypes.string.isRequired,
			content: PropTypes.string,
			position: PropTypes.string,
			tooltipPosition: PropTypes.string,
			clickable: PropTypes.bool,
			dataLabel: PropTypes.string
		})
	};
}
